// ============================================================================
// UNE ENTRÉE DU MENU DE LA CONSOLE — son libellé, et le compteur de ce qui l'attend dans la liste « À traiter ».
// Décision du 12/10 : la cloche ET des compteurs dans le menu, calculés à partir de la même liste. Chaque entrée porte
// le sien d'office : une source « À traiter » neuve qui mène à une autre page y aura son compteur sans toucher au menu.
// ============================================================================
import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { NavCount } from './triage-context';

const navClass = ({ isActive }: { isActive: boolean }) => 'nav' + (isActive ? ' active' : '');

export function RailLink({ to, end, title, children }: { to: string; end?: boolean; title?: string; children: ReactNode }) {
  return (
    <NavLink to={to} end={end} title={title} className={navClass}>
      <span style={{ flex: 1, minWidth: 0, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{children}</span>
      <NavCount to={to} />
    </NavLink>
  );
}
